<template>
  <section>
    <v-sub_banner :msgObj="subBannerInfo"></v-sub_banner>
    <b-container fluid>
      <b-row class="justify-content-center organization">
        <b-col
          cols="12"
          sm="10"
          md="9"
          xl="7"
          class="text-center flex-column justify-content-top d-flex"
        >
          <img
            src="../../assets/images/index/jigou.png"
            alt=""
            id="organizationImg"
          />
          <div class="organizationText">
            <div class="itemBoxOrg" v-for="item in textData" :key="item.name" style="text-align: justify;">
              <span>{{ item.name }}</span
              >{{ item.context }}
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
import Sub_banner from "../sub-banner.vue";
export default {
  components: {
    "v-sub_banner": Sub_banner,
  },
  data() {
    return {
      subBannerInfo: {
        // img: require("@/assets/images/sub_banner/jgsz.png"),
        img:require("@/assets/images/connect_banner.png"),
    
        title: "机构设置",
        subTitle: "Departments",
      },
      textData: [
        {
          name: "1.行政办公室。",
          context:
            "主要职责：负责中心行政事务、外事及保密管理；负责中心机构设置、人员岗位、公开招聘、职称评聘、教育培训、工资福利及社保公积金管理；负责中心财务、固定资产管理；负责中心采购管理；负责中心后勤保障；负责中心档案室建设与管理，具体负责行政和财务档案管理；负责中心合同管理；承办中心领导交办的其他事项。",
        },
        {
          name: "2.党委办公室。",
          context:
            "主要职责：负责中心党的组织、宣传、思想政治工作和精神文明建设；负责纪检和党风廉政建设；负责中心干部管理、干部监督、人事档案及年终考核管理；负责中心人才建设；负责中心工会、群团以及退休干部管理工作；承办中心领导交办的其他事项。",
        },
        {
          name: "3.科研规划处(项目管理办公室)。",
          context:
            "主要职责：根据民航局委托，组织拟订民航电子政务、民航信息化规章、标准和规范制度以及组织制定中心信息化规章、标准和规范制度；组织拟订民航电子政务建设的整体发展规划以及制定中心业务发展规划；负责开展中心科研和资质管理工作；负责中心项目建设统筹与管理工作；负责统筹协调和管理中心科技成果转化、市场推广及对外技术联络等工作；负责中心科研及建设项目档案管理；承办中心领导交办的其他事项。",
        },
        {
          name: "4.运行保障和网络安全处。",
          context:
            "主要职责：负责民航电子政务基础设施、基础应用平台、网络安全保障体系的规划、建设与运行管理；开展相关领域技术外包服务工作；负责中心网络安全管理工作；承担局机关终端日常维护服务工作；承担民航网络安全技术支持工作；负责拟订相关业务领域电子政务及信息化规章、标准和规范制度；承办中心领导交办的其他事项。",
        },
        {
          name: "5.公共服务系统建设处。",
          context:
            "主要职责：负责民航行政办公与公共服务领域的项目建设、应用支持与服务、以及成果转化和数据资源利用等工作；负责民航局政府网站和政务内网的内容保障及日常维护工作；负责拟订相关业务领域应用规划、信息化规章、标准和规范制度；承办中心领导交办的其他事项。",
        },
        {
          name: "6.安全监管系统建设处。",
          context:
            "主要职责：负责民航安全监管领域的项目建设、应用支持与服务、以及成果转化和数据资源利用等工作；负责拟订相关业务领域应用规划、信息化规章、标准和规范制度；承办中心领导交办的其他事项。",
        },
        {
          name: "7.大数据建设处。",
          context:
            "主要职责：负责民航经济运行与管理领域的项目建设、应用支持与服务、以及成果转化和数据资源利用等工作；负责民航行业政务大数据的建设与管理，承担民航行业大数据的综合衔接和利用工作；负责拟订相关业务领域应用规划、信息化规章、标准和规范制度；承办中心领导交办的其他事项。",
        },
        {
          name: "8.技术研发中心。",
          context:
            "主要职责：负责民航电子政务系统基础应用平台和应用技术架构规划及设计工作；负责横向信息化产品的设计、研发以及协助业务部门开展市场推广技术支持服务工作；负责民航电子政务重点实验室以及工程技术中心的建设和管理工作；协助业务部门开展项目质量管控和应用技术支持等工作；负责制定中心信息化系统建设与开发规范；承办中心领导交办的其他事项。",
        },
      ],
    };
  },
  watch: {},
  created() {},
  mounted() {
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      let screenWidth = window.innerWidth;
      this.setReSize(screenWidth);
    };
    this.setReSize(window.innerWidth);
  },
  methods: {
    setReSize(screenWidth) {
      if (screenWidth > 576) {
        this.subBannerInfo.img = require("@/assets/images/connect_banner.png");
      } else {
        this.subBannerInfo.img = require("@/assets/images/common_m.png");
      }
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/organization.css";
</style>
<style lang="less" scoped>
@media (max-width: 575px) {
  #organizationImg {
    padding: 50px 30px;
  }
  .organizationText {
    padding: 0 30px;
    box-sizing: border-box;
  }
  .itemBoxOrg {
    font-size: 14px;
    line-height: 2.3;
    span {
      font-size: 17px;
      
    }
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .organizationText {
  }
  .itemBoxOrg {
    font-size: 15px;
    line-height: 2.5;
    span {
      font-size: 18px;
    }
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .organizationText {
  }
  .itemBoxOrg {
    font-size: 16px;
    line-height: 2.5;
    span {
      font-size: 19px;
    }
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .organizationText {
  }
  .itemBoxOrg {
    font-size: 17px;
    span {
      font-size: 20px;
    }
  }
}
@media (min-width: 1200px) {
  .organizationText {
  }
  .itemBoxOrg {
    font-size: 18px;
    span {
      font-size: 22px;
    }
  }
}
</style>
